import {
  selectRouterPathname,
  selectRouterQueryParameters,
} from '@noths/polaris-client-next-redux';
import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from '../../combinedReducer';
import { requestProducts } from './requestProducts';

export const refetchProducts = createAsyncThunk(
  'products/refetchProducts',
  async (_payload, { getState, dispatch }) => {
    const state = getState() as ReduxApplicationState;

    const queryParams = selectRouterQueryParameters(state);
    const path = selectRouterPathname(state);

    const productsQuery = {
      ...queryParams,
      path,
    };

    await dispatch(
      requestProducts({
        query: productsQuery,
      }),
    );
  },
);
